/*
 * @Descripttion: 英文
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 15:38:51
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-30 17:51:19
 */
import headFooter from './headFooter' // 头尾
import frontPage from './frontPage' // 首页
import product from './product' // 核心产品
import scienceResearch from './scienceResearch' // 科研合作
import license from './license' // 详情许可
import about from './about' // 公司介绍
import guidance from './word/guidance' // 商务合作

const en = {
  headMenus: headFooter.headMenus,
  footer: headFooter.footer,
  frontPage: frontPage,
  product: product,
  license: license,
  scienceResearch: scienceResearch,
  about: about,
  guidance: guidance
}
export default en
